import { Injectable } from '@angular/core';
import { InputSearchApisModel } from '../../models/shared/statuscases.model';
import { inputSearchModel } from '../../view-models/testify';
import { Mapper } from '../mapper';

@Injectable({
    providedIn: 'root'
})
export class InputSearchTestifyMapper implements Mapper<InputSearchApisModel, inputSearchModel>  {
    constructor(

    ) { }
    mapForm(param: InputSearchApisModel): inputSearchModel {
        return {
            administrativeCourt: param.c_ID,
            blackNumberCase: param.seC_ID,
            suitBlackCode: param.suiT_BLACK,
            suitBlackYear: param.suiT_BLACK_YEAR,
            redNumberCase:0,
            suitRedCode:0,
            suitRedYear:0,
            suitTypeId:0,
        }
    }

    mapTo(param: inputSearchModel): InputSearchApisModel {
        return {
            c_ID: param.administrativeCourt,
            seC_ID: param.blackNumberCase,
            suiT_BLACK: param.suitBlackCode,
            suiT_BLACK_YEAR: param.suitBlackYear,
            suitTypeId:param.suitTypeId
        }
    }

} 